import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ProgressBarMode } from '@angular/material/progress-bar';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/core/app.state';
import { Actions, ofType } from '@ngrx/effects';
import { Subscription, tap } from 'rxjs';
import { Router } from '@angular/router';
import { SetLoading } from 'src/app/shared/store/shared.actions';
import { ImportComparators, ImportComparatorsError, ImportComparatorsSuccess } from '../../store/comparator.actions';
@Component({
  selector: 'app-import-comparators',
  templateUrl: './import-comparators.component.html',
  styleUrls: ['./import-comparators.component.scss']
})
export class ImportComparatorsComponent implements OnInit {
  mode: ProgressBarMode = 'determinate';
  value = 0;
  isUpload: boolean = true;
  fileName: string = 'No file selected';
  purcentageOfUpload: number = 0;
  sizeOfUpload: string = '';
  file: File | undefined;
  subscriptions: Subscription[] = [];


  constructor(
    private dialogRef: MatDialogRef<ImportComparatorsComponent>,
    private store: Store<AppState>,
    private actions$: Actions,
    private router: Router
  ) { }

  ngOnInit(): void {
    const sub1 = this.actions$.pipe(
      ofType(ImportComparatorsSuccess),
      tap((action) => {
        this.router.navigate(['comparators/add']);
        this.close();
      })).subscribe();

    const sub2 = this.actions$.pipe(
      ofType(ImportComparatorsError),
      tap(() => {
        this.close();
      })).subscribe();

    this.subscriptions.push(sub1, sub2);
  }

  close() {
    this.dialogRef.close();
  }

  onFileChange(event: any) {
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      this.file = file;
      this.fileName = file.name;
      this.isUpload = false;
      this.value = 100;
      const fileSizeKB = (file.size / 1024).toFixed(2);
      this.sizeOfUpload = fileSizeKB;
    }
  };

  upload(){
    if(this.file){
      const formData = new FormData();
      formData.append('ufile', this.file ?? '');
      this.store.dispatch(ImportComparators({file: formData, reimport: false}));
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

}
